import script from "./PCFrequentSalesOrderPackaging.vue?vue&type=script&setup=true&lang=js"
export * from "./PCFrequentSalesOrderPackaging.vue?vue&type=script&setup=true&lang=js"

import "./PCFrequentSalesOrderPackaging.vue?vue&type=style&index=0&id=2c412992&lang=scss"

const __exports__ = script;

export default __exports__